// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassOutlinedSvg from "@ant-design/icons-svg/es/asn/HourglassOutlined";
import AntdIcon from '../components/AntdIcon';

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassOutlinedSvg
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
export default React.forwardRef(HourglassOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HourglassOutlined.js
// module id = 1323
// module chunks = 0